import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { MetadataSummaryComponent } from '@mode/switch-views/ui';

export const DowngradedSwitchViewsUIModule = angular
  .module('downgraded-switch-views-ui', [])
  .directive('modeMetadataSummary', downgradeComponent({ component: MetadataSummaryComponent })).name;
